import React, { useCallback, useEffect } from "react";
import { Spinner } from "react-activity";
import "react-activity/dist/library.css";
import SuccessPage from "./SuccessPage";
import MessagePage from "./MessagePage";
import IntroPage from "./IntroPage";
import axios from "axios";

export const env = "prod";

export const url = {
  development: "http://localhost:1000",
  prod: "https://api.tulz.com.br/api",
};

export const LoadingIndicator = () => {
  return (
    <div style={styles.activityContainer}>
      <Spinner size="large" />
    </div>
  );
};

const MainPage = ({ handlePath }) => {
  const [rateValue, setRateValue] = React.useState("");
  const [text, onChangeText] = React.useState("");
  const [success, setSuccess] = React.useState(false);
  const [active, setActive] = React.useState(true);
  const [question, setQuestion] = React.useState("");
  const [company, setCompany] = React.useState({
    companyId: "",
    companyName: "",
  });

  const companyId = window.location.href.split("nps/")[1];

  const checkDeviceIsExists = async (id) => {
    const response = await axios.get(`${url[env]}/config-web?unitKeyBox=${id}`);
    return response.data.hasDevice;
  };

  const getQuestion = async (id) => {
    const response = await axios.get(`${url[env]}/config?unitKeyBox=${id}`);
    return response.data;
  };

  const fetchQuestion = async (companyId) => {
    try {
      if (question) return;

      const hasDevice = await checkDeviceIsExists(companyId);

      if (hasDevice === false) {
        handlePath("/painel");
        return;
      } else {
        const question = await getQuestion(companyId);
        setQuestion(question.data_question);
        setCompany({
          companyId,
          companyName: question.data_company_name,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getValuation = (note) => {
    const numberValuation = Number(note);
    if (numberValuation <= 6) {
      return "unsatisfied";
    }
    if (numberValuation <= 8) {
      return "neutral";
    }
    if (numberValuation <= 10) {
      return "satisfied";
    }
  };

  const handleRateValue = (value) => setRateValue(value);

  const handleBack = () => {
    setRateValue("");
  };

  // signIn() uses the emailPassword authentication provider to log in

  const onSubmit = React.useCallback(async (data) => {
    try {
      const response = await axios.post(`${url[env]}/feedback/enviar`, data);
      if (response.status === 201) {
        setSuccess(true);
      } else {
        alert("Ocorreu um erro, por favor tente novamente!");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setTimeout(() => {
        handleBack();
        setSuccess(false);
      }, 4000);
    }
  }, []);

  useEffect(() => {
    fetchQuestion(companyId);
  }, []);

  if (success) {
    return (
      <SuccessPage
        rateValue={rateValue}
        message={text}
        companyId={company.companyId}
        companyName={company.companyName}
      />
    );
  }

  if (rateValue) {
    return (
      <MessagePage
        active={active}
        handleBack={handleBack}
        onChangeText={onChangeText}
        onSubmit={() =>
          onSubmit({
            summary: "Nota: " + rateValue,
            data_evaluation: getValuation(rateValue),
            data_message: text,
            data_box_key: company.companyId,
            data_company_name: company.companyName,
          })
        }
        setActive={setActive}
      />
    );
  }

  return <IntroPage handleRateValue={handleRateValue} question={question} />;
};

const styles = {
  footerText: {
    fontSize: 12,
    textAlign: "center",
    marginVertical: 4,
  },
  hyperlink: {
    color: "blue",
  },
  footer: {
    paddingHorizontal: 24,
    paddingVertical: 12,
  },
  activityContainer: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "space-around",
    padding: 10,
  },
};

export default MainPage;
